import ContinueButton from '@app-studio-web/ui/components/ContinueButton'
import { useTranslation } from 'react-i18next'
import { Form } from 'react-router-dom'
import QuizLayout from './QuizLayout'

const QUOTE = 'pages.quizOnboarding.testimonial.quote'

export default function TestimonialPage() {
  const { t } = useTranslation()

  return (
    <QuizLayout>
      <div className="flex grow flex-col items-center justify-center">
        <div className="mx-auto w-full max-w-md rounded-3xl border border-[#e2e8f0] bg-white p-7 shadow-sm">
          <div className="mb-3 flex justify-center gap-1 text-lg text-[#ffb400]">
            <span>★</span>
            <span>★</span>
            <span>★</span>
            <span>★</span>
            <span>★</span>
          </div>

          <p className="text-custom-black text-center text-[17px] leading-relaxed text-balance">
            {t(QUOTE)}
          </p>

          <p className="text-custom-black mt-5 text-center font-bold">
            {t('pages.quizOnboarding.testimonial.attribution')}
          </p>
          <p className="text-center text-sm text-[#94a3b8]">
            {t('pages.quizOnboarding.testimonial.since')}
          </p>
        </div>
      </div>

      <Form className="shrink-0" method="post">
        <input
          name={t(QUOTE, { lng: 'en' })}
          type="hidden"
          value={t('shared.continue', { lng: 'en' })}
        />

        <ContinueButton />
      </Form>
    </QuizLayout>
  )
}
